var windowWidth, lazyImages, lazyBackground, lazyIframe, lazyScripts, src, style, datasrc, urls, analytics, s, x, i, j, flag;
document.addEventListener('DOMContentLoaded', function () {
  windowWidth = screen.width
  lazyImages = document.querySelectorAll('img.lazy')
  lazyBackground = document.querySelectorAll('.lazybg')
  lazyIframe = document.querySelectorAll('iframe.lazy')
  lazyIvideo = document.querySelectorAll('video.lazy')
  lazyScripts = document.getElementsByTagName('script')
  i = 0
  j = 0
  flag = !0
  window.addEventListener('scroll', function () {
    init()
  })
  window.addEventListener('mousemove', function () {
    init()
  })
  window.addEventListener('touchstart', function () {
    init()
  })
  setTimeout(function () {
    init()
  }, 3300)
  /*if(document.querySelector('.bg_overlay_.lazyload') != null){
   // document.querySelectorAll('.bg_overlay_.lazyload').forEach(function(elem) {
var elem = document.querySelector('.bg_overlay_.lazyload');
      var bg = elem.getAttribute('data-bgset');
      var res = bg.split(",");
      var res2 = res[8].split(" ");
      elem.parentElement.style.background = 'url('+res2[0]+')';
     elem.parentElement.style.backgroundPosition = "top";
      elem.parentElement.style.backgroundRepeat = "no-repeat";
      elem.parentElement.style.backgroundSize = "cover";
       elem.parentElement.style.visibility = "visible";
       elem.style.background = "none";
   // })
  }*/
})

function init () {

  if (flag != 0) {

    flag = 0
    lazyLoadImg()
    lazyLoadBackground()
    lazyLoadIframe()
    load_all_js()
  }
}

function lazyLoadImg () {
  lazyImages.forEach(function (elem) {
    if (windowWidth < 600) {
      src = ( elem.dataset.mobsrc == undefined ) ? elem.dataset.src : elem.dataset.mobsrc
    } else {
      src = elem.dataset.src
    }

    if (src != null) {
      elem.src = src
    }
  })
}

function lazyLoadBackground () {
  lazyBackground.forEach(function (elem) {
    if (windowWidth < 600) {
      style = ( elem.dataset.mobstyle == undefined ) ? elem.dataset.style : elem.dataset.mobstyle
    } else {
      style = elem.dataset.style
    }

    if (style != null) {
      elem.style = style
    }
  })
}

function lazyLoadIframe () {
  lazyIframe.forEach(function (elem) {
    datasrc = elem.dataset.src
    if (datasrc != null) {
      elem.src = datasrc
    }
  })

  lazyIvideo.forEach(function (elem) {
    datasrc = elem.dataset.src
    if (datasrc != null) {
      elem.src = datasrc
    }
  })
}

function lazyLoadScripts () {
  if (typeof lazyScripts[ j ] == 'undefined') {
    return
  }

  if (lazyScripts[ j ].getAttribute('type') == 'lazyload2') {
    lazyScripts[ j ].setAttribute('type', 'lazyloaded')
    if (typeof lazyScripts[ j ].dataset.src !== 'undefined') {
      s = document.createElement('script')
      s.type = 'text/javascript'
      s.async = !0
      s.src = lazyScripts[ j ].dataset.src
      x = document.getElementsByTagName('body')[ 0 ]
      x.appendChild(s)
      s.onload = function () {
        j++
        lazyLoadScripts()
      }
    } else {
      s = document.createElement('script')
      s.type = 'text/javascript'
      s.async = !0
      s.innerHTML = lazyScripts[ j ].innerHTML
      x = document.getElementsByTagName('body')[ 0 ]
      x.appendChild(s)
      j++
      lazyLoadScripts()
    }
  } else {
    j++
    lazyLoadScripts()
  }
}

function lazyLoadCss (url) {
  s = document.createElement('link')
  s.rel = 'stylesheet'
  s.href = url
  x = document.getElementsByTagName('head')[ 0 ]
  x.appendChild(s)
}

function lazyLoadJS (url) {
  s = document.createElement('script')
  s.type = 'text/javascript'
  s.async = !0
  s.src = url
  x = document.getElementsByTagName('body')[ 0 ]
  x.appendChild(s)
}

function asyncLoad () {
  urls = []

  for (i = 0; i < urls.length; i++) {
    s = document.createElement('script')
    s.type = 'text/javascript'
    s.async = true
    s.src = urls[ i ]
    x = document.getElementsByTagName('script')[ 0 ]
    x.parentNode.insertBefore(s, x)
  }
  setTimeout(function () {
    analyticscall()
  }, 200)

}

function load_all_js () {
  //	asyncLoad();

  j = 0
  lazyLoadScripts()
  lazyLoadCss('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css')
  lazyLoadCss('https://searchanise-ef84.kxcdn.com/styles.8J7T2s4d8L.css')
  lazyLoadCss('https://cdn1.stamped.io/files/widget.min.css')
  //lazyLoadCss('https://use.fontawesome.com/releases/v5.3.1/css/all.css');
  //lazyLoadCss('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
  //lazyLoadCss('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.9/slick.min.css');
  //lazyLoadCss('https://cdnjs.cloudflare.com/ajax/libs/malihu-custom-scrollbar-plugin/3.1.5/jquery.mCustomScrollbar.min.css');
  //lazyLoadCss('//cdn-images.mailchimp.com/embedcode/classic-10_7.css');
  //lazyLoadCss("{{ 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick-theme.min.css'}}");
  //lazyLoadCss("{{ 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.css'}}");
}

if (document.querySelectorAll('img.lazyload') != null) {
  document.querySelectorAll('img.lazyload').forEach(function (elem) {
    var str = elem.getAttribute('data-src')
    if (str !== null) { // Check if str is not null
      elem.src = str.replace('{width}', '360')
      elem.style.opacity = '1'
    }
  })
}

if (document.querySelector('.skrim__overlay.lazyload') != null) {
  document.querySelectorAll('.skrim__overlay.lazyload').forEach(function (elem) {
    var bg = elem.getAttribute('data-bgset')
    var res = bg.split(',')

    var res2 = res[ 2 ].split(' ')

    elem.style.background = 'url(' + res2[ 2 ] + ')'
    elem.style.backgroundPosition = 'center center'
    elem.style.backgroundRepeat = 'no-repeat'

  })
}

function analyticscall () {
  analytics = document.getElementsByClassName('analytics')
  if (analytics != null) {
    s = document.createElement('script')
    s.type = 'text/javascript'
    s.innerHTML = analytics[ 0 ].innerHTML;
    x = document.getElementsByTagName("body")[ 0 ];
    x.appendChild(s);
  }
}